function getts(){
  let date = new Date()
  let str = date.getTime()
  return str.toString()
}

function correct(n){
  return n>9?n:"0"+n
}

function getMinutes(time){
  let date = new Date(time * 1000)
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  let d = date.getDate()
  let hour = date.getHours()
  let minute = date.getMinutes()
  let result = year + "年" + month + "月" + d + "日 " + correct(hour) + ":" + correct(minute)
  return result
}
function getDate(time){
  let date = new Date(time * 1000)
  let year = date.getFullYear()
  year =correct(year)
  let month = date.getMonth() + 1
  month = correct(month)
  let d = date.getDate()
  d = correct(d)
  let result = year + "." + month + "." + d 
  return result
}
function dealArticle(content){
  let div = document.createElement("div")
  div.innerHTML = content
  return div.innerText
}
export default{
  getts: getts,
  getMinutes,
  getDate,
  dealArticle
}


// WEBPACK FOOTER //
// ./src/utils/index.js